export const timezonesList = [
	{ label: '(GMT-12:00) International Date Line West', value: -12 },
	{ label: '(GMT-11:00) Midway Island, Samoa', value: -11 },
	{ label: '(GMT-10:00) Hawaii', value: -10 },
	{ label: '(GMT-08:00) Pacific Time (US & Canada)', value: -8 },
	{ label: '(GMT-09:00) Alaska', value: -9 },
	{ label: '(GMT-08:00) Tijuana, Baja California', value: -8 },
	{ label: '(GMT-07:00) Arizona', value: -7 },
	{ label: '(GMT-07:00) Chihuahua, La Paz, Mazatlan', value: -7 },
	{ label: '(GMT-07:00) Mountain Time (US & Canada)', value: -7 },
	{ label: '(GMT-06:00) Central America', value: -6 },
	{ label: '(GMT-06:00) Central Time (US & Canada)', value: -6 },
	{ label: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco', value: -5 },
	{ label: '(GMT-05:00) Eastern Time (US & Canada)', value: -5 },
	{ label: '(GMT-05:00) Indiana (East)', value: -5 },
	{ label: '(GMT-04:00) Atlantic Time (Canada)', value: -4 },
	{ label: '(GMT-04:00) Caracas, La Paz', value: -4 },
	{ label: '(GMT-04:00) Manaus', value: -4 },
	{ label: '(GMT-04:00) Santiago', value: -4 },
	{ label: '(GMT-03:30) Newfoundland', value: -3.5 },
	{ label: '(GMT-03:00) Brasilia', value: -3 },
	{ label: '(GMT-03:00) Buenos Aires, Georgetown', value: -3 },
	{ label: '(GMT-03:00) Greenland', value: -3 },
	{ label: '(GMT-03:00) Montevideo', value: -3 },
	{ label: '(GMT-02:00) Mid-Atlantic', value: -2 },
	{ label: '(GMT-01:00) Cape Verde Is.', value: -1 },
	{ label: '(GMT-01:00) Azores', value: -1 },
	{ label: '(GMT+00:00) Casablanca, Monrovia, Reykjavik', value: 0 },
	{
		label:
			'(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
		value: 0,
	},
	{
		label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		value: 1,
	},
	{
		label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		value: 1,
	},
	{ label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris', value: 1 },
	{ label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 1 },
	{ label: '(GMT+01:00) West Central Africa', value: 1 },
	{ label: '(GMT+02:00) Amman', value: 2 },
	{ label: '(GMT+02:00) Athens, Bucharest, Istanbul', value: 2 },
	{ label: '(GMT+02:00) Beirut', value: 2 },
	{ label: '(GMT+02:00) Cairo', value: 2 },
	{ label: '(GMT+02:00) Harare, Pretoria', value: 2 },
	{
		label: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
		value: 2,
	},
	{ label: '(GMT+02:00) Jerusalem', value: 2 },
	{ label: '(GMT+03:00) Minsk', value: 3 },
	{ label: '(GMT+02:00) Windhoek', value: 2 },
	{ label: '(GMT+03:00) Kuwait, Riyadh, Baghdad', value: 3 },
	{ label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd', value: 3 },
	{ label: '(GMT+03:00) Nairobi', value: 3 },
	{ label: '(GMT+03:00) Tbilisi', value: 3 },
	{ label: '(GMT+03:30) Tehran', value: 3.5 },
	{ label: '(GMT+04:00) Abu Dhabi, Muscat', value: 4 },
	{ label: '(GMT+04:00) Baku', value: 4 },
	{ label: '(GMT+04:00) Yerevan', value: 4 },
	{ label: '(GMT+04:30) Kabul', value: 4.5 },
	{ label: '(GMT+05:00) Yekaterinburg', value: 5 },
	{ label: '(GMT+05:00) Islamabad, Karachi, Tashkent', value: 5 },
	{ label: '(GMT+05:30) Sri Jayawardenapura', value: 5.5 },
	{ label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 5.5 },
	{ label: '(GMT+05:45) Kathmandu', value: 5.75 },
	{ label: '(GMT+06:00) Almaty, Novosibirsk', value: 6 },
	{ label: '(GMT+06:00) Astana, Dhaka', value: 6 },
	{ label: '(GMT+06:30) Yangon (Rangoon)', value: 6.5 },
	{ label: '(GMT+07:00) Bangkok, Hanoi, Jakarta', value: 7 },
	{ label: '(GMT+07:00) Krasnoyarsk', value: 7 },
	{ label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi', value: 8 },
	{ label: '(GMT+08:00) Kuala Lumpur, Singapore', value: 8 },
	{ label: '(GMT+08:00) Irkutsk, Ulaan Bataar', value: 8 },
	{ label: '(GMT+08:00) Perth', value: 8 },
	{ label: '(GMT+08:00) Taipei', value: 8 },
	{ label: '(GMT+09:00) Osaka, Sapporo, Tokyo', value: 9 },
	{ label: '(GMT+09:00) Seoul', value: 9 },
	{ label: '(GMT+09:00) Yakutsk', value: 9 },
	{ label: '(GMT+09:30) Adelaide', value: 9.5 },
	{ label: '(GMT+09:30) Darwin', value: 9.5 },
	{ label: '(GMT+10:00) Brisbane', value: 10 },
	{ label: '(GMT+10:00) Canberra, Melbourne, Sydney', value: 10 },
	{ label: '(GMT+10:00) Hobart', value: 10 },
	{ label: '(GMT+10:00) Guam, Port Moresby', value: 10 },
	{ label: '(GMT+10:00) Vladivostok', value: 10 },
	{ label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia', value: 11 },
	{ label: '(GMT+12:00) Auckland, Wellington', value: 12 },
	{ label: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.', value: 12 },
	{ label: "(GMT+13:00) Nuku'alofa", value: 13 },
];

export const timezonesListDST = [
	{ label: '(GMT-12:00) International Date Line West', value: -12 },
	{ label: '(GMT-11:00) Midway Island, Samoa', value: -11 },
	{ label: '(GMT-10:00) Hawaii', value: -10 },
	{ label: '(GMT-07:00) Pacific Time (US & Canada)', value: -7 }, // +1
	{ label: '(GMT-08:00) Alaska', value: -8 }, // +1
	{ label: '(GMT-07:00) Tijuana, Baja California', value: -7 }, // +1
	{ label: '(GMT-07:00) Arizona', value: -7 },
	{ label: '(GMT-06:00) Chihuahua, La Paz, Mazatlan', value: -6 }, // +1
	{ label: '(GMT-06:00) Mountain Time (US & Canada)', value: -6 }, // +1
	{ label: '(GMT-05:00) Central America', value: -5 }, // +1
	{ label: '(GMT-05:00) Central Time (US & Canada)', value: -5 }, // +1
	{ label: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco', value: -5 },
	{ label: '(GMT-05:00) Eastern Time (US & Canada)', value: -5 },
	{ label: '(GMT-04:00) Indiana (East)', value: -4 }, // +1
	{ label: '(GMT-03:00) Atlantic Time (Canada)', value: -3 }, // +1
	{ label: '(GMT-04:00) Caracas, La Paz', value: -4 },
	{ label: '(GMT-04:00) Manaus', value: -4 },
	{ label: '(GMT-03:00) Santiago', value: -3 }, // +1
	{ label: '(GMT-02:30) Newfoundland', value: -2.5 }, // +1
	{ label: '(GMT-03:00) Brasilia', value: -3 },
	{ label: '(GMT-03:00) Buenos Aires, Georgetown', value: -3 },
	{ label: '(GMT-02:00) Greenland', value: -2 }, // +1
	{ label: '(GMT-03:00) Montevideo', value: -3 },
	{ label: '(GMT-02:00) Mid-Atlantic', value: -2 },
	{ label: '(GMT-01:00) Cape Verde Is.', value: -1 },
	{ label: '(GMT-00:00) Azores', value: 0 }, // +1
	{ label: '(GMT+00:00) Casablanca, Monrovia, Reykjavik', value: 0 },
	{
		label:
			'(GMT+01:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
		value: 1,
	}, // +1
	{
		label: '(GMT+02:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		value: 2,
	}, // +1
	{
		label: '(GMT+02:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		value: 2,
	}, // +1
	{ label: '(GMT+02:00) Brussels, Copenhagen, Madrid, Paris', value: 2 }, // +1
	{ label: '(GMT+02:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 2 }, // +1
	{ label: '(GMT+01:00) West Central Africa', value: 1 },
	{ label: '(GMT+03:00) Amman', value: 3 }, // +1
	{ label: '(GMT+03:00) Athens, Bucharest, Istanbul', value: 3 }, // +1
	{ label: '(GMT+03:00) Beirut', value: 3 }, // +1
	{ label: '(GMT+02:00) Cairo', value: 2 },
	{ label: '(GMT+02:00) Harare, Pretoria', value: 2 },
	{
		label: '(GMT+03:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
		value: 3,
	}, // +1
	{ label: '(GMT+03:00) Jerusalem', value: 3 }, // +1
	{ label: '(GMT+03:00) Minsk', value: 3 },
	{ label: '(GMT+02:00) Windhoek', value: 2 },
	{ label: '(GMT+03:00) Kuwait, Riyadh, Baghdad', value: 3 },
	{ label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd', value: 3 },
	{ label: '(GMT+03:00) Nairobi', value: 3 },
	{ label: '(GMT+03:00) Tbilisi', value: 3 },
	{ label: '(GMT+04:30) Tehran', value: 4.5 }, // +1
	{ label: '(GMT+04:00) Abu Dhabi, Muscat', value: 4 },
	{ label: '(GMT+04:00) Baku', value: 4 },
	{ label: '(GMT+04:00) Yerevan', value: 4 },
	{ label: '(GMT+04:30) Kabul', value: 4.5 },
	{ label: '(GMT+05:00) Yekaterinburg', value: 5 },
	{ label: '(GMT+05:00) Islamabad, Karachi, Tashkent', value: 5 },
	{ label: '(GMT+05:30) Sri Jayawardenapura', value: 5.5 },
	{ label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 5.5 },
	{ label: '(GMT+05:45) Kathmandu', value: 5.75 },
	{ label: '(GMT+06:00) Almaty, Novosibirsk', value: 6 },
	{ label: '(GMT+06:00) Astana, Dhaka', value: 6 },
	{ label: '(GMT+06:30) Yangon (Rangoon)', value: 6.5 },
	{ label: '(GMT+07:00) Bangkok, Hanoi, Jakarta', value: 7 },
	{ label: '(GMT+07:00) Krasnoyarsk', value: 7 },
	{ label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi', value: 8 },
	{ label: '(GMT+08:00) Kuala Lumpur, Singapore', value: 8 },
	{ label: '(GMT+08:00) Irkutsk, Ulaan Bataar', value: 8 },
	{ label: '(GMT+08:00) Perth', value: 8 },
	{ label: '(GMT+08:00) Taipei', value: 8 },
	{ label: '(GMT+09:00) Osaka, Sapporo, Tokyo', value: 9 },
	{ label: '(GMT+09:00) Seoul', value: 9 },
	{ label: '(GMT+09:00) Yakutsk', value: 9 },
	{ label: '(GMT+10:30) Adelaide', value: 10.5 }, // +1
	{ label: '(GMT+09:30) Darwin', value: 9.5 },
	{ label: '(GMT+10:00) Brisbane', value: 10 },
	{ label: '(GMT+11:00) Canberra, Melbourne, Sydney', value: 11 }, // +1
	{ label: '(GMT+11:00) Hobart', value: 11 }, // +1
	{ label: '(GMT+10:00) Guam, Port Moresby', value: 10 },
	{ label: '(GMT+10:00) Vladivostok', value: 10 },
	{ label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia', value: 11 },
	{ label: '(GMT+12:00) Auckland, Wellington', value: 12 },
	{ label: '(GMT+13:00) Fiji, Kamchatka, Marshall Is.', value: 13 }, // +1
	{ label: "(GMT+13:00) Nuku'alofa", value: 13 },
];

export const countries = [
	{ name: 'Afghanistan', code: 'AF' },
	{ name: 'Albania', code: 'AL' },
	{ name: 'Algeria', code: 'DZ' },
	{ name: 'Andorra', code: 'AD' },
	{ name: 'Angola', code: 'AO' },
	{ name: 'Antigua and Barbuda', code: 'AG' },
	{ name: 'Argentina', code: 'AR' },
	{ name: 'Armenia', code: 'AM' },
	{ name: 'Australia', code: 'AU' },
	{ name: 'Austria', code: 'AT' },
	{ name: 'Azerbaijan', code: 'AZ' },
	{ name: 'Bahamas', code: 'BS' },
	{ name: 'Bahrain', code: 'BH' },
	{ name: 'Bangladesh', code: 'BD' },
	{ name: 'Barbados', code: 'BB' },
	{ name: 'Belarus', code: 'BY' },
	{ name: 'Belgium', code: 'BE' },
	{ name: 'Belize', code: 'BZ' },
	{ name: 'Benin', code: 'BJ' },
	{ name: 'Bhutan', code: 'BT' },
	{ name: 'Bolivia (Plurinational State of)', code: 'BO' },
	{ name: 'Bosnia and Herzegovina', code: 'BA' },
	{ name: 'Botswana', code: 'BW' },
	{ name: 'Brazil', code: 'BR' },
	{ name: 'Brunei Darussalam', code: 'BN' },
	{ name: 'Bulgaria', code: 'BG' },
	{ name: 'Burkina Faso', code: 'BF' },
	{ name: 'Burundi', code: 'BI' },
	{ name: 'Cabo Verde', code: 'CV' },
	{ name: 'Cambodia', code: 'KH' },
	{ name: 'Cameroon', code: 'CM' },
	{ name: 'Canada', code: 'CA' },
	{ name: 'Central African Rep.', code: 'CF' },
	{ name: 'Chad', code: 'TD' },
	{ name: 'Chile', code: 'CL' },
	{ name: 'China', code: 'CN' },
	{ name: 'Colombia', code: 'CO' },
	{ name: 'Comoros', code: 'KM' },
	{ name: 'Congo (Rep. of the)', code: 'CG' },
	{ name: 'Costa Rica', code: 'CR' },
	{ name: "Côte d'Ivoire", code: 'CI' },
	{ name: 'Croatia', code: 'HR' },
	{ name: 'Cuba', code: 'CU' },
	{ name: 'Cyprus', code: 'CY' },
	{ name: 'Czech Republic', code: 'CZ' },
	{ name: "Dem. People's Rep. of Korea", code: 'KP' },
	{ name: 'Dem. Rep. of the Congo', code: 'CD' },
	{ name: 'Denmark', code: 'DK' },
	{ name: 'Djibouti', code: 'DJ' },
	{ name: 'Dominica', code: 'DM' },
	{ name: 'Dominican Rep.', code: 'DO' },
	{ name: 'Ecuador', code: 'EC' },
	{ name: 'Egypt', code: 'EG' },
	{ name: 'El Salvador', code: 'SV' },
	{ name: 'Equatorial Guinea', code: 'GQ' },
	{ name: 'Eritrea', code: 'ER' },
	{ name: 'Estonia', code: 'EE' },
	{ name: 'Eswatini', code: 'SZ' },
	{ name: 'Ethiopia', code: 'ET' },
	{ name: 'Fiji', code: 'FJ' },
	{ name: 'Finland', code: 'FI' },
	{ name: 'France', code: 'FR' },
	{ name: 'Gabon', code: 'GA' },
	{ name: 'Gambia', code: 'GM' },
	{ name: 'Georgia', code: 'GE' },
	{ name: 'Germany', code: 'DE' },
	{ name: 'Ghana', code: 'GH' },
	{ name: 'Greece', code: 'GR' },
	{ name: 'Grenada', code: 'GD' },
	{ name: 'Guatemala', code: 'GT' },
	{ name: 'Guinea', code: 'GN' },
	{ name: 'Guinea-Bissau', code: 'GW' },
	{ name: 'Guyana', code: 'GY' },
	{ name: 'Haiti', code: 'HT' },
	{ name: 'Honduras', code: 'HN' },
	{ name: 'Hungary', code: 'HU' },
	{ name: 'Iceland', code: 'IS' },
	{ name: 'India', code: 'IN' },
	{ name: 'Indonesia', code: 'ID' },
	{ name: 'Iran (Islamic Republic of)', code: 'IR' },
	{ name: 'Iraq', code: 'IQ' },
	{ name: 'Ireland', code: 'IE' },
	{ name: 'Israel', code: 'IL' },
	{ name: 'Italy', code: 'IT' },
	{ name: 'Jamaica', code: 'JM' },
	{ name: 'Japan', code: 'JP' },
	{ name: 'Jordan', code: 'JO' },
	{ name: 'Kazakhstan', code: 'KZ' },
	{ name: 'Kenya', code: 'KE' },
	{ name: 'Kiribati', code: 'KI' },
	{ name: 'Korea (Rep. of)', code: 'KR' },
	{ name: 'Kuwait', code: 'KW' },
	{ name: 'Kyrgyzstan', code: 'KG' },
	{ name: 'Lao P.D.R.', code: 'LA' },
	{ name: 'Latvia', code: 'LV' },
	{ name: 'Lebanon', code: 'LB' },
	{ name: 'Lesotho', code: 'LS' },
	{ name: 'Liberia', code: 'LR' },
	{ name: 'Libya', code: 'LY' },
	{ name: 'Liechtenstein', code: 'LI' },
	{ name: 'Lithuania', code: 'LT' },
	{ name: 'Luxembourg', code: 'LU' },
	{ name: 'Madagascar', code: 'MG' },
	{ name: 'Malawi', code: 'MW' },
	{ name: 'Malaysia', code: 'MY' },
	{ name: 'Maldives', code: 'MV' },
	{ name: 'Mali', code: 'ML' },
	{ name: 'Malta', code: 'MT' },
	{ name: 'Marshall Islands', code: 'MH' },
	{ name: 'Mauritania', code: 'MR' },
	{ name: 'Mauritius', code: 'MU' },
	{ name: 'Mexico', code: 'MX' },
	{ name: 'Micronesia', code: 'FM' },
	{ name: 'Moldova', code: 'MD' },
	{ name: 'Monaco', code: 'MC' },
	{ name: 'Mongolia', code: 'MN' },
	{ name: 'Montenegro', code: 'ME' },
	{ name: 'Morocco', code: 'MA' },
	{ name: 'Mozambique', code: 'MZ' },
	{ name: 'Myanmar', code: 'MM' },
	{ name: 'Namibia', code: 'NA' },
	{ name: 'Nauru', code: 'NR' },
	{ name: 'Nepal (Republic of)', code: 'NP' },
	{ name: 'Netherlands (Kingdom of the)', code: 'NL' },
	{ name: 'New Zealand', code: 'NZ' },
	{ name: 'Nicaragua', code: 'NI' },
	{ name: 'Niger', code: 'NE' },
	{ name: 'Nigeria', code: 'NG' },
	{ name: 'North Macedonia', code: 'MK' },
	{ name: 'Norway', code: 'NO' },
	{ name: 'Oman', code: 'OM' },
	{ name: 'Pakistan', code: 'PK' },
	{ name: 'Palau', code: 'PW' },
	{ name: 'Panama', code: 'PA' },
	{ name: 'Papua New Guinea', code: 'PG' },
	{ name: 'Paraguay', code: 'PY' },
	{ name: 'Peru', code: 'PE' },
	{ name: 'Philippines', code: 'PH' },
	{ name: 'Poland', code: 'PL' },
	{ name: 'Portugal', code: 'PT' },
	{ name: 'Qatar', code: 'QA' },
	{ name: 'Resolution 99 (State of Palestine)', code: 'PS' },
	{ name: 'Romania', code: 'RO' },
	{ name: 'Russian Federation', code: 'RU' },
	{ name: 'Rwanda', code: 'RW' },
	{ name: 'Saint Kitts and Nevis', code: 'KN' },
	{ name: 'Saint Lucia', code: 'LC' },
	{ name: 'Saint Vincent and the Grenadines', code: 'VC' },
	{ name: 'Samoa', code: 'WS' },
	{ name: 'San Marino', code: 'SM' },
	{ name: 'Sao Tome and Principe', code: 'ST' },
	{ name: 'Saudi Arabia', code: 'SA' },
	{ name: 'Senegal', code: 'SN' },
	{ name: 'Serbia', code: 'RS' },
	{ name: 'Seychelles', code: 'SC' },
	{ name: 'Sierra Leone', code: 'SL' },
	{ name: 'Singapore', code: 'SG' },
	{ name: 'Slovakia', code: 'SK' },
	{ name: 'Slovenia', code: 'SI' },
	{ name: 'Solomon Islands', code: 'SB' },
	{ name: 'Somalia', code: 'SO' },
	{ name: 'South Africa', code: 'ZA' },
	{ name: 'South Sudan', code: 'SS' },
	{ name: 'Spain', code: 'ES' },
	{ name: 'Sri Lanka', code: 'LK' },
	{ name: 'Sudan', code: 'SD' },
	{ name: 'Suriname', code: 'SR' },
	{ name: 'Sweden', code: 'SE' },
	{ name: 'Switzerland', code: 'CH' },
	{ name: 'Syrian Arab Republic', code: 'SY' },
	{ name: 'Tajikistan', code: 'TJ' },
	{ name: 'Tanzania', code: 'TZ' },
	{ name: 'Thailand', code: 'TH' },
	{ name: 'Timor-Leste', code: 'TL' },
	{ name: 'Togo', code: 'TG' },
	{ name: 'Tonga', code: 'TO' },
	{ name: 'Trinidad and Tobago', code: 'TT' },
	{ name: 'Tunisia', code: 'TN' },
	{ name: 'Türkiye', code: 'TR' },
	{ name: 'Turkmenistan', code: 'TM' },
	{ name: 'Tuvalu', code: 'TV' },
	{ name: 'Uganda', code: 'UG' },
	{ name: 'Ukraine', code: 'UA' },
	{ name: 'United Arab Emirates', code: 'AE' },
	{ name: 'United Kingdom', code: 'GB' },
	{ name: 'United States', code: 'US' },
	{ name: 'Uruguay', code: 'UY' },
	{ name: 'Uzbekistan', code: 'UZ' },
	{ name: 'Vanuatu', code: 'VU' },
	{ name: 'Vatican', code: 'VA' },
	{ name: 'Venezuela', code: 'VE' },
	{ name: 'Viet Nam', code: 'VN' },
	{ name: 'Yemen', code: 'YE' },
	{ name: 'Zambia', code: 'ZM' },
	{ name: 'Zimbabwe', code: 'ZW' },
];

export const stripeCurrencies = [
	{ currencyCode: 'usd', minimumAmmount: 1 },
	{ currencyCode: 'eur', minimumAmmount: 1 },
];

export const monthKeyList = [
	'january',
	'february',
	'march',
	'april',
	'may',
	'june',
	'july',
	'august',
	'september',
	'october',
	'november',
	'december',
];

export const DEFAULT_MEDIA_KINDS = ['audio', 'video'];

export const USER_ROLES = {
	organizer: 'organizer',
	exhibitor: 'exhibitor',
	participant: 'participant',
};

export const EXHIBITOR_TYPES = {
	company: 'company',
	scholar: 'scholar',
};
